import { drypApi } from "@/services/drypApi";

export const unit = {
	getAllUnits: async (): Promise<Dryp.UnitInfo[]> => {
		return await drypApi.get<Dryp.UnitInfo[]>(`/api/units`);
	},
};
